var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFinnWhite = function SvgFinnWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 26,
    viewBox: "0 0 75 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4333_7587)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 26V0H16.604V6.2452H6.31922V10.8616H14.2603V17.1068H6.31922V26H0ZM26.4537 0H20.1345V26H26.4537V0ZM44.4027 13.1899V0H50.7219V26H45.6487L36.2935 11.8309V26H29.9842V0H35.7694L44.4027 13.1899ZM68.6808 13.1899V0H75V26H69.9169L60.5716 11.8309V26H54.2524V0H60.0475L68.6808 13.1899Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4333_7587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 26,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFinnWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FINN-white.df2a1c9d8e8edc0da79cae2cd52ac90a.svg";